define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/FInspAsset", "../entity/FInspDoc", "../../utils/TimeUtil", "../domain", "../services", "../services/EventManager", "./FInspApproval"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, FInspAsset_1, FInspDoc_1, TimeUtil_1, domain_1, services_1, EventManager_1, FInspApproval_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FInspection = void 0;
    class FInspection extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "FacilityId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Lga", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LgaCodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StStartDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StStartDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseTravellingStock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseTravellingStockError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseAgistingStock", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseAgistingStockError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UsePrivate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UsePrivateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseOther", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UseOtherError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UserComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UserCommentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Status", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusReq", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusReqError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusPrev", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusPrevError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusCommentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemState", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SystemStateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FInspAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFInspAsset", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FInspAssetError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FInspDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFInspDoc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FInspDocError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Facility", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IncludeNotPresentAssets", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Approval", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsLoaded", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FInspection.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Facility = parent;
            this.FacilityId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.FInspAsset = [];
            this.FInspDoc = [];
        }
        onRead(entity, parent) {
            this.Facility = parent;
            this.FInspAsset = [];
            this.FInspDoc = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.FacilityId = (0, EntityUtil_1.toInt)(entity.FacilityId);
            a.RefId = b.RefId;
            a.Lga = b.Lga;
            a.LgaCode = b.LgaCode;
            a.StStartDate = b.StStartDate;
            a.UseTravellingStock = (0, EntityUtil_1.toInt)(entity.UseTravellingStock);
            a.UseAgistingStock = (0, EntityUtil_1.toInt)(entity.UseAgistingStock);
            a.UsePrivate = (0, EntityUtil_1.toInt)(entity.UsePrivate);
            a.UseOther = (0, EntityUtil_1.toInt)(entity.UseOther);
            a.UserComment = b.UserComment;
            a.Status = (0, EntityUtil_1.toInt)(entity.Status);
            a.StatusReq = (0, EntityUtil_1.toInt)(entity.StatusReq);
            a.StatusPrev = (0, EntityUtil_1.toInt)(entity.StatusPrev);
            a.StatusUser = b.StatusUser;
            a.StatusDate = b.StatusDate;
            a.StatusComment = b.StatusComment;
            a.SystemState = (0, EntityUtil_1.toInt)(entity.SystemState);
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditEditUser = b.AuditEditUser;
            a.AuditEditDate = b.AuditEditDate;
            a.FInspAsset = this.mergeArray(a.FInspAsset, b.FInspAsset, FInspAsset_1.FInspAsset);
            a.SelectedFInspAsset = a.SelectedFInspAsset && a.FInspAsset.find(x => x.Id == a.SelectedFInspAsset.Id) ? a.SelectedFInspAsset : null;
            a.FInspDoc = this.mergeArray(a.FInspDoc, b.FInspDoc, FInspDoc_1.FInspDoc);
            a.SelectedFInspDoc = a.SelectedFInspDoc && a.FInspDoc.find(x => x.Id == a.SelectedFInspDoc.Id) ? a.SelectedFInspDoc : null;
            a.Shape = (0, EntityUtil_1.mergePoint)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
            this.Approval && this.Approval.evaluateStatus();
        }
        onReady() {
            this.Approval = new FInspApproval_1.FInspApproval(this);
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FInspection.AliasName);
            this.reset();
            if (!this.IsMarkedForDeletion && this.IsActive && this.Approval.IsPendingReviewOrConfirmed) {
                this._validate(validationState, recurseChildren);
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqString(validationState, "RefId", "Reference Id");
                this.validateReqString(validationState, "Lga", "LGA ");
                this.validateReqString(validationState, "LgaCode", "LGA Code");
                this.validateReqNumber(validationState, "UseTravellingStock", "Used by Travelling Stock?");
                this.validateReqNumber(validationState, "UseAgistingStock", "Used by Agisting Stock?");
                this.validateReqNumber(validationState, "UsePrivate", "Is Privately Used?");
                this.validateReqNumber(validationState, "UseOther", "Other Usage?");
                this.validateReqNumber(validationState, "Status", "Inspection Status (Actual)");
                this.validateReqString(validationState, "StatusUser", "Inspection Status Changed By");
                this.validateReqDate(validationState, "StatusDate", "Inspection Status Change Date");
                this.validateReqNumber(validationState, "SystemState", "System State");
                this.validateReqString(validationState, "AuditCreateUser", "AUDIT_CREATE_USER");
                this.validateReqDate(validationState, "AuditCreateDate", "AUDIT_CREATE_DATE");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.FInspAsset) {
                for (let x of this.FInspAsset) {
                    x.walk(func, { leading });
                }
            }
            if (this.FInspDoc) {
                for (let x of this.FInspDoc) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                FacilityId: this.FacilityId,
                RefId: this.RefId,
                Lga: this.Lga,
                LgaCode: this.LgaCode,
                StStartDate: this.StStartDate,
                UseTravellingStock: this.UseTravellingStock,
                UseAgistingStock: this.UseAgistingStock,
                UsePrivate: this.UsePrivate,
                UseOther: this.UseOther,
                UserComment: this.UserComment,
                Status: this.Status,
                StatusReq: this.StatusReq,
                StatusPrev: this.StatusPrev,
                StatusUser: this.StatusUser,
                StatusDate: this.StatusDate,
                StatusComment: this.StatusComment,
                SystemState: this.SystemState,
                AuditCreateUser: this.AuditCreateUser,
                AuditCreateDate: this.AuditCreateDate,
                AuditEditUser: this.AuditEditUser,
                AuditEditDate: this.AuditEditDate,
                FInspAsset: this.FInspAsset.map(x => x.toJson()),
                FInspDoc: this.FInspDoc.map(x => x.toJson()),
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get IsUserPriviledgedToEdit() {
            return this.SecurityAccessLevel == EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        get IsReadOnly() {
            return this.Facility.IsReadOnly || !this.IsUserPriviledgedToEdit || this.SystemState == domain_1.FacilitySysStatusDomain.Archived || this.Status != domain_1.FacilityInspStatusDomain.Draft;
        }
        get IsActive() {
            return this.SystemState == domain_1.FacilitySysStatusDomain.Active;
        }
        get IsAmendmentModeActive() {
            return this.IsActive && (this.Status == domain_1.FacilityInspStatusDomain.Refused || this.Status == domain_1.FacilityInspStatusDomain.PendingReview);
        }
        get StatusValue() {
            var _a;
            let k = this.StatusReq ? this.StatusReq : this.Status;
            let v = (_a = domain_1.FacilityInspStatusDomain.findByKey(k)) === null || _a === void 0 ? void 0 : _a.value;
            return this.StatusReq ? `${v}*` : v;
        }
        get StocktakePeriod() {
            if (!!this.StStartDate) {
                let fyEndDate = TimeUtil_1.TimeUtil.getLastDayOfAustralianFiscalYear(new Date(this.StStartDate));
                let fyStartDate = new Date(fyEndDate.getFullYear() - 1, 6, 1);
                return fyStartDate.getFullYear() + "-" + fyEndDate.getFullYear();
            }
            else {
                return "Unassigned";
            }
        }
        get ActiveAssets() {
            return this.FInspAsset.filter(a => a.Status != domain_1.FAssetStatusDomain.NotPresent);
        }
        static create(f) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating Inspection");
                services_1.SrmsServiceManager.Instance.Facility.createFacilityInspection(f.toJson()).then(insp => {
                    let x = new FInspection(insp, f);
                    f.FInspection.push(x);
                    resolve(x);
                });
            });
        }
        lazyLoad() {
            return new Promise((resolve, reject) => {
                if (this.PersistanceState == EntityBase_1.PersistanceStates.NEW_RECORD) {
                    this.IsLoaded = true;
                }
                if (!this.IsLoaded) {
                    (0, EventManager_1.notify)("Loading Inspection");
                    services_1.SrmsServiceManager.Instance.Facility.readFacilityInspection(this.Id, true).then(insp => {
                        this.merge(insp);
                        this.IsLoaded = true;
                        resolve(this);
                    });
                }
                resolve(null);
            });
        }
        updateGeometry(geometry) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Updating Inspection");
                this.Shape = geometry;
                services_1.SrmsServiceManager.Instance.Facility.getFacilityLgaOnGeometryChange(this.Shape).then(res => {
                    if (res && res.LgaName && res.LgaCode) {
                        this.Lga = res.LgaName;
                        this.LgaCode = res.LgaCode;
                    }
                    resolve();
                }).catch(err => {
                    reject(err);
                });
            });
        }
    }
    exports.FInspection = FInspection;
    Object.defineProperty(FInspection, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FInspection"
    });
    Object.defineProperty(FInspection, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Inspection"
    });
    Object.defineProperty(FInspection, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "FacilityId", "RefId", "Lga", "LgaCode", "StStartDate", "UseTravellingStock", "UseAgistingStock", "UsePrivate", "UseOther", "UserComment", "Status", "StatusReq", "StatusPrev", "StatusUser", "StatusDate", "StatusComment", "SystemState", "AuditCreateUser", "AuditCreateDate", "AuditEditUser", "AuditEditDate", "Shape"]
    });
    Object.defineProperty(FInspection, "FacilityIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspection, "RefIdLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 50
    });
    Object.defineProperty(FInspection, "RefIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "LgaLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 128
    });
    Object.defineProperty(FInspection, "LgaReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "LgaCodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 10
    });
    Object.defineProperty(FInspection, "LgaCodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "StStartDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspection, "UseTravellingStockReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "UseAgistingStockReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "UsePrivateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "UseOtherReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "UserCommentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2048
    });
    Object.defineProperty(FInspection, "UserCommentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspection, "StatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "StatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "StatusReqDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "StatusReqReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspection, "StatusPrevDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "StatusPrevReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspection, "StatusUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FInspection, "StatusUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "StatusDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "StatusCommentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2046
    });
    Object.defineProperty(FInspection, "StatusCommentTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter any supporting information relevant to the approval decision"
    });
    Object.defineProperty(FInspection, "StatusCommentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspection, "SystemStateDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "SystemStateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FInspection, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspection, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FInspection, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspection, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "FacilityId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "FacilityIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "RefId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "RefIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "Lga", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "LgaError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "LgaCode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "LgaCodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StStartDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StStartDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "UseTravellingStock", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "UseTravellingStockError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "UseAgistingStock", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "UseAgistingStockError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "UsePrivate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "UsePrivateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "UseOther", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "UseOtherError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "UserComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "UserCommentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "Status", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StatusReq", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StatusReqError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StatusPrev", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StatusPrevError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StatusUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StatusUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StatusDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StatusDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StatusComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "StatusCommentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "SystemState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "SystemStateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "FInspAsset", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "SelectedFInspAsset", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "FInspAssetError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "FInspDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "SelectedFInspDoc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "FInspDocError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "Facility", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspection.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspection.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspection.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "IncludeNotPresentAssets", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "Approval", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspection.prototype, "IsUserPriviledgedToEdit", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspection.prototype, "IsReadOnly", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspection.prototype, "IsActive", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspection.prototype, "IsAmendmentModeActive", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspection.prototype, "StatusValue", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspection.prototype, "StocktakePeriod", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspection.prototype, "ActiveAssets", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspection.prototype, "IsLoaded", void 0);
});
